@solidale.controller 'HomeCtrl', ['$rootScope', '$scope', '$location', '$timeout', ($rootScope, $scope, $location, $timeout) ->
	
	$scope.phase = 1
	$scope.bubbles = []
	$scope.bubbleCount = 0

	$addBubble = ()->
		$timeout ()->
			$scope.bubbles.push 1
			$scope.$apply()

			if $scope.bubbleCount < 4
				$scope.bubbleCount += 1
				$addBubble()
			else
				$scope.phase = 2	

		, 1000

	$addBubble()


]